// src/components/tabs/tabs.styles.ts
import { tv } from "tailwind-variants";
var tabsStyles = tv({
  slots: {
    container: ["flex flex-col"],
    tabs: ["flex", "justify-left", "gap-6"],
    tab: [
      "pt-4 pr-4",
      "text-lg font-bold text-neutral-55 text-left",
      "cursor-pointer"
    ],
    tabIndicator: ["bg-transparent", "h-1", "w-full", "mt-4", "rounded-sm"],
    tabContent: ["border-t border-neutral-200 leading-7"]
  },
  variants: {
    active: {
      true: {
        tab: ["text-secondary"],
        tabIndicator: ["bg-secondary"]
      }
    }
  }
});
export {
  tabsStyles
};
